import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import UserDrivingRecord from "../../../../features/User/UserDrivingRecord/UserDrivingRecord";

export const Route = createFileRoute("/(app)/users/$id/driving-record")({
  component: RouteComponent,
  // The calendar's view and date, so back, reload and shared links keep them; a bad value falls back to this week.
  validateSearch: z.object({
    view: z.enum(["week", "month", "year"]).optional().catch(undefined),
    date: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .refine((d) => !Number.isNaN(Date.parse(d)))
      .optional()
      .catch(undefined),
  }),
});

function RouteComponent() {
  const { id } = Route.useParams();
  return <UserDrivingRecord id={Number(id)} />;
}
